/**
 * 协议内容总入口
 *
 * 页面 HTML 与各语言文案分离：
 *   - 页面模板：src/agreements/<type>/template.js（语言无关）
 *   - 语言文案：src/i18n/zh-CN.js（统一中文，按命名空间分组）+ src/i18n/<lang>.js（翻译，只写差异）
 *
 * 说明：user 与 privacy 为两个独立文档，不再共用同一模板：
 *   - user    → src/agreements/user/template.js          （用户协议，文案提取至 zh-CN.js 的 user 命名空间）
 *   - privacy → src/agreements/privacy/template.js      （隐私政策，文案提取至 zh-CN.js 的 privacy 命名空间）
 *
 * @param {string} lang     语言代码，如 zh-CN / en / ja
 * @param {string} type     协议类型：user | privacy | cancel | permission | member
 * @param {string} brandKey 品牌名（URL 参数 appname），用于切换公司主体信息
 * @returns {{ html: string, locale: object }}
 */
import { getLocale } from '../i18n'
import memberTpl from './member/template'
import cancelTpl from './cancel/template'
import permissionTpl from './permission/template'
import userTpl from './user/template'
import privacyTpl from './privacy/template'

const templates = {
  member: memberTpl,
  cancel: cancelTpl,
  permission: permissionTpl,
  user: userTpl,
  privacy: privacyTpl
}

export function getAgreement(lang, type = 'user', brandKey) {
  const t = templates[type] ? type : 'user'
  const locale = getLocale(lang, brandKey)
  return {
    html: templates[t],
    locale: {
      common: locale.common || {},
      [t]: locale[t] || {}
    }
  }
}

export default getAgreement
